import { Component, Input, ElementRef } from '@angular/core';
import { ValuesExchangeProvider } from '../../providers/values.exchange/values.exchange.provider';
@Component({
  selector: 'nrwl-helpicon',
  templateUrl: './helpicon.component.html',
  styleUrls: ['./helpicon.component.scss']
})
export class HelpIconComponent {
  @Input() helpId: any; // eslint-disable-line
  constructor(private readonly elementRef: ElementRef, private readonly exchange: ValuesExchangeProvider) {}

  openDialog(): void {
    this.exchange.notifyListeners('help_dialog', {
      id: this.helpId,
      helpIconEl: this.elementRef
    });
  }
}
